import filesize from 'filesize';
import PropTypes from 'prop-types';
import React from 'react';

const DisplayFileSize = ({file}) => {
  return (
    <div className={'align-items-center d-flex'}>
      <div>
        {filesize(file.size)}
      </div>
    </div>
  );
};

DisplayFileSize.propTypes = {
  file: PropTypes.shape({
    size: PropTypes.number.isRequired,
  }).isRequired,
};

export default DisplayFileSize;
